import update from 'immutability-helper';
import {
  FETCH_RECOMMENDED_POI_SUCCESS,
  FETCH_RECOMMENDED_POI_FAIL,
  FETCH_RECOMMENDED_POI,
  RESET_RECOMMENDED_POI,
  SET_RECOMMENDED_POI,
  SEARCH_POI_SUCCESS,
  SEARCH_POI_FAIL,
  SEARCH_POI,
  CLEAR_POI_LIST,
  FETCH_POI_DETAIL_FROM_POI_BANK_SUCCESS,
  FETCH_POI_DETAIL_FROM_POI_BANK_FAIL,
  POI_BANK_CITY_GEOCODE_SUCCESS,
  POI_BANK_CITY_GEOCODE_FAIL,
  ADD_POI_SUCCESS,
} from './../actions/action_types';
import {
  POI_DETAIL_TYPE_FOR_RECOMMENDATIONS,
  POI_DETAIL_TYPE_FOR_SEARCH_POIS,
} from './view_state';
import {
  POI_BANK_NEXT_URL_TYPE_FACEBOOK,
  POI_BANK_NEXT_URL_TYPE_WEB_SITE,
  POI_BANK_NEXT_URL_TYPE_TWITTER,
  POI_BANK_NEXT_URL_TYPE_WIKI,
} from './../utilities/constants';
import {
  convertPoisFromPoiBank,
  convertPoiFromPoiBank,
} from './../utilities/convert_poi_util';
import assignDeep from '../utilities/assign-deep';

export default (
  state = {
    recommendedPoiList: {
      code: null,
      data: [],
      skip: 0,
      nextPage: false,
      error: null,
      resetPage: false,
      loading: false,
    },
    cityGeocodeList: {
      data: [],
      error: null,
    },
    // refactor: should move to runtimeVariable
    searchInfo: {
      city: { id: '', name: '' },
      keyword: '',
      coordinate: [],
      showAccurateSearch: false,
    },
  },
  action,
) => {
  // console.log('recommended poi list reducer state = ', action.type);
  switch (action.type) {
    case FETCH_RECOMMENDED_POI:
      return handleFetchRecommendedPoi(state, action.payload);
    case RESET_RECOMMENDED_POI:
      return {
        ...assignDeep(state, {
          recommendedPoiList: {
            code: null,
            data: [],
            nextPage: false,
            resetPage: true,
          },
          cityGeocodeList: {
            data: [],
          },
          searchInfo: {
            showAccurateSearch: false,
          },
        }),
      };
    case SET_RECOMMENDED_POI:
      return { ...assignDeep(state, action.payload) };
    case FETCH_RECOMMENDED_POI_SUCCESS:
      return handleFetchRecommendedPoiSuccess(state, action.payload.results);
    case FETCH_RECOMMENDED_POI_FAIL:
      return {
        ...state,
        recommendedPoiList: {
          data: state.recommendedPoiList.data,
          skip: state.recommendedPoiList.skip,
          nextPage: false,
          error: action.payload,
          resetPage: false,
        },
      };
    case SEARCH_POI:
      return handleSearchPoi(state, action.payload);
    case SEARCH_POI_SUCCESS:
      return handleSearchPoiSuccess(state, action.payload.results);
    case SEARCH_POI_FAIL:
      return {
        ...assignDeep(state, {
          recommendedPoiList: {
            code: 4,
            resetPage: false,
            loading: false,
          },
        }),
      };
    case FETCH_POI_DETAIL_FROM_POI_BANK_SUCCESS:
      return handleFetchPoiDetailFromPoiBankSuccess(
        state,
        action.payload.poiObjectId,
        action.payload.type,
        action.payload.results,
      );
    case FETCH_POI_DETAIL_FROM_POI_BANK_FAIL:
      return handleFetchPoiDetailFromPoiBankFail(
        state,
        action.payload.poiObjectId,
        action.payload.type,
        action.payload.results,
      );
    case POI_BANK_CITY_GEOCODE_SUCCESS:
      return {
        ...state,
        cityGeocodeList: {
          data: action.payload.results,
          error: null,
        },
      };
    case POI_BANK_CITY_GEOCODE_FAIL:
      return {
        ...state,
        cityGeocodeList: {
          data: [],
          error: action.payload,
        },
      };
    // should not display same search content for next time
    // clear poi list after add poi success for
    case ADD_POI_SUCCESS:
    case CLEAR_POI_LIST:
      return {
        recommendedPoiList: {
          data: [],
          skip: 0,
          nextPage: false,
          error: null,
        },
        cityGeocodeList: {
          data: [],
          error: null,
        },
        searchInfo: {
          ...state.searchInfo,
          keyword: '',
          showAccurateSearch: false,
        },
      };
    default:
      return state;
  }
};

const handleFetchRecommendedPoi = (state, payload) => {
  return {
    ...assignDeep(state, {
      recommendedPoiList: {
        loading: true,
      },
    }),
  };
};

const handleFetchRecommendedPoiSuccess = (state, results) => {
  const { code, data, data_next: nextPage } = results;
  const convertedData = convertPoisFromPoiBank(data);
  const pois = [...state.recommendedPoiList.data, ...convertedData];

  return {
    ...assignDeep(state, {
      recommendedPoiList: {
        code,
        data: pois,
        nextPage,
        resetPage: false,
        loading: false,
      },
      cityGeocodeList: {
        data: [],
      },
    }),
  };
};

const handleSearchPoi = (state, payload) => {
  return state;
};

const handleSearchPoiSuccess = (state, results) => {
  const { code, data, data_next: nextPage } = results;
  const convertedData = convertPoisFromPoiBank(data || []);
  const pois = [...state.recommendedPoiList.data, ...convertedData];

  return {
    ...assignDeep(state, {
      recommendedPoiList: {
        code,
        data: pois,
        nextPage,
        resetPage: false,
        loading: false,
      },
      cityGeocodeList: {
        data: [],
      },
    }),
  };
};

const findPoiById = (data, poiObjectId) => {
  let poi = null;
  let index;
  for (let i = 0; i < data.length; i++) {
    const object = data[i];
    if (object._id === poiObjectId) {
      poi = object;
      index = i;
      break;
    }
  }
  return { index, poi };
};

// fetch poi detail from poi bank
const handleFetchPoiDetailFromPoiBankSuccess = (
  state,
  poiObjectId,
  type,
  results,
) => {
  if (
    type !== POI_DETAIL_TYPE_FOR_RECOMMENDATIONS &&
    type !== POI_DETAIL_TYPE_FOR_SEARCH_POIS
  ) {
    return state;
  }

  const poiDetail = { ...results };
  const { urls } = poiDetail;
  let data;
  if (type === POI_DETAIL_TYPE_FOR_RECOMMENDATIONS) {
    data = state.recommendedPoiList.data;
  } else if (type === POI_DETAIL_TYPE_FOR_SEARCH_POIS) {
    data = state.recommendedPoiList.data;
  }

  if (!data) {
    return state;
  }

  const { poi, index } = findPoiById(data, poiObjectId);

  if (index === null || !poi) {
    return state;
  }

  // urls
  if (urls) {
    for (let i = 0; i < results.urls.length; i++) {
      const url = results.urls[i];
      if (url.type === POI_BANK_NEXT_URL_TYPE_WEB_SITE) {
        poiDetail.website = url.url;
      } else if (url.type === POI_BANK_NEXT_URL_TYPE_FACEBOOK) {
        poiDetail.facebook = results.url;
      } else if (url.type === POI_BANK_NEXT_URL_TYPE_WIKI) {
        poiDetail.wiki = url.url;
      } else if (url.type === POI_BANK_NEXT_URL_TYPE_TWITTER) {
        poiDetail.twitter = url.url;
      }
    }
    delete poiDetail.urls;
  }

  if (type === POI_DETAIL_TYPE_FOR_RECOMMENDATIONS) {
    return update(state, {
      recommendedPoiList: {
        data: {
          [index]: {
            poiDetail: { $set: convertPoiFromPoiBank(poiDetail) },
            name: { $set: poiDetail.name },
            address: { $set: poiDetail.address },
          },
        },
      },
    });
  } else if (type === POI_DETAIL_TYPE_FOR_SEARCH_POIS) {
    return update(state, {
      recommendedPoiList: {
        data: {
          [index]: {
            poiDetail: { $set: convertPoiFromPoiBank(poiDetail) },
            name: { $set: poiDetail.name },
            address: { $set: poiDetail.address },
          },
        },
      },
    });
  }

  return state;
};

const handleFetchPoiDetailFromPoiBankFail = (
  state,
  poiObjectId,
  type,
  results,
) => {
  if (
    type !== POI_DETAIL_TYPE_FOR_RECOMMENDATIONS &&
    type !== POI_DETAIL_TYPE_FOR_SEARCH_POIS
  ) {
    return state;
  }

  const itinerary = state.data;
  if (!itinerary) {
    console.warn(
      'itinerary data 為 undefined 只會在 dev 環境發生、因為 dev 資料會包含 prod DB 景點，但是 dev 環境點擊景點時打 poi/show/ API 僅向 dev DB 查詢，這時當然找不到 prod 景點資料，此警告在 dev 環境可忽略，若在 prod 環境出現即有問題',
      '是故這時畫面顯示連線錯誤..乃是正常情境',
    );
    return state;
  }
  const { poi, index } = findPoiById(itinerary, poiObjectId);

  if (index === null || !poi) {
    return state;
  }

  if (type === POI_DETAIL_TYPE_FOR_RECOMMENDATIONS) {
    return update(state, {
      recommendedPoiList: {
        data: {
          [index]: {
            poiDetail: { $set: null },
          },
        },
      },
    });
  } else if (type === POI_DETAIL_TYPE_FOR_SEARCH_POIS) {
    return update(state, {
      recommendedPoiList: {
        data: {
          [index]: {
            poiDetail: { $set: null },
          },
        },
      },
    });
  }

  return state;
};
